export const ART_PORTRAIT = 'ART_PORTRAIT'
export const ART_LANDSCAPE = 'ART_LANDSCAPE'
